export const GET_BANNER_MESSAGES = "GET_BANNER_MESSAGES"
export const GET_BANNER_MESSAGES_SUCCESS = "GET_BANNER_MESSAGES_SUCCESS"
export const GET_BANNER_MESSAGES_ERROR = "GET_BANNER_MESSAGES_ERROR"

export const DELETE_BANNER_MESSAGES = "DELETE_BANNER_MESSAGES"
export const DELETE_BANNER_MESSAGES_SUCCESS = "DELETE_BANNER_MESSAGES_SUCCESS"
export const DELETE_BANNER_MESSAGES_ERROR = "DELETE_BANNER_MESSAGES_ERROR"

export const GET_ADMIN_USER_BANNER_MESSAGES = "GET_ADMIN_USER_BANNER_MESSAGES"
export const GET_ADMIN_USER_BANNER_MESSAGES_SUCCESS = "GET_ADMIN_USER_BANNER_MESSAGES_SUCCESS"
export const GET_ADMIN_USER_BANNER_MESSAGES_ERROR = "GET_ADMIN_USER_BANNER_MESSAGES_ERROR"

export const DELETE_ADMIN_USER_BANNER_MESSAGES = "DELETE_ADMIN_USER_BANNER_MESSAGES"
export const DELETE_ADMIN_USER_BANNER_MESSAGES_SUCCESS = "DELETE_ADMIN_USER_BANNER_MESSAGES_SUCCESS"
export const DELETE_ADMIN_USER_BANNER_MESSAGES_ERROR = "DELETE_ADMIN_USER_BANNER_MESSAGES_ERROR"